import { render, staticRenderFns } from "./PreviewBoxes.vue?vue&type=template&id=b1c72586&"
import script from "./PreviewBoxes.vue?vue&type=script&lang=ts&"
export * from "./PreviewBoxes.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports